export function initTranslate() {
  $(".js-translate").change(function (e) {
    // console.log("====");
    // console.log(e.target.value);
    // console.log("====");
    if (e.target.value) {
      location.href =
        "https://translate.google.com/translate?sl=en&tl=" +
        e.target.value +
        "&u=" +
        location.href;
    }
  });
}
